import React, { useContext } from 'react'
import ClockContext from '../../context/clockContext'
import NotficationContext, {
  INotification,
} from '../../context/notficationContext'
import './footer.css'
import { Github, LinkedIn, Dribble, Email, Clock, User, Note } from '../svg/svg'
import { capitalizeFirstLetter } from '../../utils/utext'
import { useFormik } from 'formik'
import axios from '../../axios'
import * as Yup from 'yup'

const contactSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  lastName: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
  message: Yup.string()
    .min(2, 'Too Short!')
    .max(150, 'Too Long!')
    .required('Required'),
})

const Footer = () => {
  const { setNotifications, notifications } = useContext(NotficationContext)
  const formik = useFormik({
    initialValues: {
      email: '',
      firstName: '',
      lastName: '',
      message: '',
    },
    onSubmit: async (values, { resetForm }) => {
      contactSchema
        .validate(values)
        .then(async (values) => {
          try {
            const description = `:robot:\tName: ${capitalizeFirstLetter(
              values.firstName
            )} ${capitalizeFirstLetter(
              values.lastName
            )}\n:incoming_envelope:\tEmail: ${
              values.email
            }\n:speech_balloon:\tMessage: ${'```' + values.message + '```'}`
            const webhook = {
              id: '982717094862913539',
              token:
                '14aTvpsoK7m78ty_FfCZWzT6KNImlubVp7b9yXWphvOTqw8QERoNwDr60Ojg4nQsxmNz',
            }
            const embeds = [
              {
                title: ':loudspeaker: New Message',
                description,
                color: 5174599,
                footer: {
                  text: `📅 ${new Date().toDateString()}`,
                },
              },
            ]
            let data = JSON.stringify({
              embeds,
              content: '<@689126680371134613>',
            })
            const config = {
              headers: { 'Content-Type': 'application/json' },
            }
            await axios.post(
              `/webhooks/${webhook.id}/${webhook.token}`,
              data,
              config
            )
            const LastNotifications = [...notifications]
            const response: INotification = {
              message: 'Message sent',
              type: 'success',
            }
            LastNotifications.push(response)
            setNotifications(LastNotifications)
            resetForm()
          } catch (err: any) {
            if (err.response !== undefined) {
              const LastNotifications = [...notifications]
              const error: INotification = {
                message: 'Message not sent',
                reasons: ['request failed with errors'],
                type: 'fail',
              }
              LastNotifications.push(error)
              setNotifications(LastNotifications)
            }
          }
        })
        .catch((err) => {
          const LastNotifications = [...notifications]
          const error: INotification = {
            message: 'Message not sent',
            reasons: [`${err.path} is ${err.message.toLowerCase()}`],
            type: 'fail',
          }
          LastNotifications.push(error)
          setNotifications(LastNotifications)
        })
    },
  })
  const clock = useContext(ClockContext)
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-main-head">
            <h1>MOSTAFA-IZADLOO</h1>
            <ul className="footer-socials">
              <li>
                <a href="https://github.com/Moizadloo">
                  <Github />
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/mostafa-izadloo-2812111a2/">
                  <LinkedIn />
                </a>
              </li>
              <li>
                <a href="https://dribbble.com/Mostafa-Izadloo">
                  <Dribble />
                </a>
              </li>
            </ul>
          </div>
          <hr />
          <div className="footer-main-message">
            <p>
              Feel free to contact me through email or the provided contact form. 
              I strive to answer your messages within 48 hours.
            </p>
            <p>In my current location, it is:</p>
            <div className="footer-clock">
              <Clock />
              <p>{clock.time[0] + ' : ' + clock.time[1]}</p>
            </div>
          </div>
          <hr />
          <ul className="footer-main-contact">
            <li>
              <Email />
              <p>moizadloo@gmail.com</p>
            </li>
          </ul>
        </div>
        <div className="footer-form">
          <form onSubmit={formik.handleSubmit}>
            <div className="footer-form-names">
              <div className="footer-input-container">
                <User />
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  placeholder="First Name"
                  spellCheck="false"
                  onChange={formik.handleChange}
                  value={formik.values.firstName}
                />
              </div>
              <div className="footer-input-container">
                <User />
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  placeholder="Last Name"
                  spellCheck="false"
                  onChange={formik.handleChange}
                  value={formik.values.lastName}
                />
              </div>
            </div>
            <div className="footer-input-container">
              <Email />
              <input
                id="email"
                name="email"
                type="email"
                placeholder="Email"
                spellCheck="false"
                onChange={formik.handleChange}
                value={formik.values.email}
              />
            </div>
            <div className="footer-input-container  footer-textarea">
              <Note />
              <textarea
                id="message"
                name="message"
                placeholder="How Can I Help You?"
                spellCheck="false"
                onChange={formik.handleChange}
                value={formik.values.message}
              />
            </div>
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </footer>
  )
}

export default Footer
